import { css } from '@emotion/react';
import { noop } from 'lodash';
import { memo } from 'react';
import ReactPlayer from 'react-player/lazy';

import { Dialog, type DialogProps } from '@didaskill/ui/design-system';

export type VideoResourceItemDialogProps = {
  isOpen?: DialogProps['isOpen'];
  onRequestClose?: DialogProps['onRequestClose'];
  videoHref: string;
};

export const VideoResourceItemDialogBase = ({
  isOpen = false,
  onRequestClose = noop,
  videoHref,
}: VideoResourceItemDialogProps) => (
  <Dialog isOpen={isOpen} onRequestClose={onRequestClose} size={Dialog.SIZES.LARGE}>
    <div
      css={css`
        width: 800px;
        height: 500px;
        padding-top: 40px;
        padding-left: 5px;
      `}
    >
      <ReactPlayer width={790} height={445} url={videoHref} controls />
    </div>
  </Dialog>
);

VideoResourceItemDialogBase.displayName = 'VideoResourceItemDialog';

export default memo(VideoResourceItemDialogBase);
